import { useClassNames } from "@/utils/classNames";
import { formatTime } from "@/utils/FormatTime";

import styles from "./Timestamp.module.scss";
import { TimestampProps } from "./types";

/**
 * Timestamp component displays the current playback time
 * Typically shown above the scrubber when the user is dragging
 *
 * @param currentTime - Current playback time in seconds
 * @param className - Additional CSS class for styling
 * @returns The Timestamp component
 */
const Timestamp = ({ currentTime, className }: TimestampProps) => {
  const cn = useClassNames(styles, styles["timestamp"], className);

  return <div className={cn}>{formatTime(currentTime)}</div>;
};

export { Timestamp };
